import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

// view

import Loading from 'components/Loading';
import {
  EditExpenses,
  ExpensesList,
  AllExpensesList,
  HrTimestampList,
  BillingList,
  ExpensesDetail,
  BillingDetail,
  Payment,
  NewPayment,
  ExpensesDaily,
  HrExpenseApproverSettings,
  FinanceSummary,
  FinanceArchive,
  FinanceActivityLog,
  ExpensesRecurringManage,
} from '../views/Finance';
import { OcrDailyVerification } from '../views/Accounting';
//

import ModuleIndexRedirect from '../components/ModuleIndexRedirect';
import { HomeNavbar } from '../components/Nevbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import { NotFound, AccessDenied } from '../components/Error';
import { hasModuleAccess } from '../utils/functions/accessRight';
import * as actions from '../redux/actions';

export function Finance() {
  const module = 'FINANCE';
  const prefix = '/finance';
  const name = 'finance';
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const me = useSelector((state) => state.me);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };
  useEffect(() => {
    dispatch(actions.meGet());

    return () => {};
  }, []);
  const isEmbed =
    new URLSearchParams(window.location.search).get('embed') === '1' &&
    /^\/finance\/expenses\/detail\//.test(pathname);

  if (!me.userData) {
    return <Loading />;
  }
  if (!hasModuleAccess(me, module)) {
    return <AccessDenied moduleLabel="การเงิน" />;
  }
  return (
    <div className="min-h-screen">
      {!isEmbed && (
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
      )}
      {!isEmbed && <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />}

      <div className={`relative min-h-screen pt-2 px-8 transition-all duration-200 ${isEmbed ? '' : 'lg:ml-20'}`}>
        <div className="py-4">
          <Switch>
            {' '}
            <Route exact path={`${prefix}/expenses`}>
              <ExpensesList title="รายการเบิกเงิน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/expenses/all`}>
              <AllExpensesList title="รายการตั้งเบิกทั้งหมด" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/expenses/recurring`}>
              <ExpensesRecurringManage title="รายการเบิกประจำ" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/expenses/edit/:id`}>
              <EditExpenses title="แก้ไข" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/expenses/detail/:id`}>
              <ExpensesDetail title="รายละเอียด" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/billing`}>
              <BillingList title="วางบิล" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/daily-report`}>
              <ExpensesDaily title="รายงานรายวัน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/Payment`}>
              <Payment title="เตรียมจ่ายเงิน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/Payment/add`}>
              <NewPayment title="เพิ่มการจ่ายเงิน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/billing/detail/:id`}>
              <BillingDetail title="รายละเอียด" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/timestamp`}>
              <HrTimestampList title="บันทึกเวลา" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/expense-approvers`}>
              <HrExpenseApproverSettings
                title="ตั้งค่าผู้อนุมัติรายการเบิกเงิน"
                subtitle={name}
              />
            </Route>
            <Route exact path={`${prefix}/summary`}>
              <FinanceSummary title="สรุปการเงิน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/summary/archive`}>
              <FinanceArchive title="Archive — รายการที่เสร็จสิ้นแล้ว" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/activity-log`}>
              <FinanceActivityLog title="บันทึกกิจกรรม (การเงิน)" />
            </Route>
            <Route exact path={`${prefix}/bank-reconciliation`}>
              <OcrDailyVerification title="กระทบยอดธนาคารรายวัน" subtitle={name} />
            </Route>
            <Route exact path={prefix}>
              <ModuleIndexRedirect moduleName="FINANCE" moduleLabel="การเงิน" />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </div>
      </div>
      {!isEmbed && (
        <div className={`${'lg:ml-20'} transition-all duration-200`}>
          <MainFooter />
        </div>
      )}
    </div>
  );
}

export default Finance;
